import axios from "axios";

export default function EntrylocationemployeeSafetyService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/entry_location_employee/" + id + "/safety",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
